import * as React from 'react';

import './Heading.css'

export interface HeadingProps {
	text: string;
	image: string;
}

export default class Heading extends React.Component<HeadingProps> {

	public render() {
		let src = `/images/${this.props.image}.png`

		return ( 
			<div className="heading">
				<div className="heading-title-container green">
					<div className="heading-image-container green">
						<img src={process.env.PUBLIC_URL + src} className="heading-image"/>
					</div>
					<h3 className="heading-title">{this.props.text}</h3>
					<div className="heading-pages">
						{this.props.children}
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/heading/Heading.tsx